__turbopack_context__.v({
  "aspectContainer": "Image-module-scss-module__vs0ebG__aspectContainer",
  "image": "Image-module-scss-module__vs0ebG__image",
  "imagePosition": "Image-module-scss-module__vs0ebG__imagePosition",
});
